const PHONE_NUMBERS = {
  CUSTOMER_SERVICE: '1-888-836-3939',
  LONG_DISTANCE: '1-888-303-6927',
};

export default PHONE_NUMBERS;
